enum Role {
  ADMIN = 'admin'
}

export default Role;
